
const tabList = [
  {
    title: '网站首页',
    src: '/',
  },
  {
    title: '走近篮协',
    src: '/introduce',
    default: '0201',
    subList: [
      {
        title: '协会简介',
        id: '0201'
      },
      {
        title: '组织架构',
        id: '0202'
      },
      {
        title: '协会会员',
        id: '0203'
      },
      {
        title: '联系我们',
        id: '0204'
      },
    ]
  },
  {
    title: '新闻中心',
    src: '/news',
    default: '0301',
    subList: [
      {
        title: '官方消息',
        id: '0301'
      },
      {
        title: '最新动态',
        id: '0302'
      },
      {
        title: '精彩视频',
        id: '0303'
      },
      {
        title: '精彩图片',
        id: '0304',
      }
    ],
  },
  {
    title: '篮球赛事',
    src: '/matches',
  },
  {
    title: '篮球培训',
    src: '/training',
    subList: [
      {
        title: '裁判员培训',
        id: '0501'
      },
      {
        title: '教练员培训',
        id: '0502'
      },

      {
        title: '小篮球培训',
        id: '0503'
      },
      {
        title: '裁判员/教练员认证',
        id: '0504'
      },
  
      // {
      //   title: '持证裁判员',
      //   id: '0503'
      // },
      // {
      //   title: '持证教练员',
      //   id: '0504'
      // },
    ],
  },
  {
    title: '各区篮协',
    src: '/associations',
  },
];

const groupUrl = '/group';
const personUrl = '/personal';

const whiteList = [
    {
      path: '/login',
      desc: '欢迎回来',
      desc_en: 'Welcome back'
    },
    {
      path: '/register',
      desc: '欢迎注册',
      desc_en: 'Welcome to register'
    },
    {
      path: personUrl + '/center',
      desc: "个人中心",
      desc_en: 'Personal Center'
    },
    {
      path: groupUrl + '/center',
      desc: "团体中心",
      desc_en: 'Group home page'
    },
    {
      path: '/forgetpwd',
      desc: '找回密码',
      desc_en: 'Find the password',
    },
    {
      path: '/activity/list',
      desc: '动态列表',
      desc_en: 'Activity List'
    },
    {
      path: '/activity/edit',
      desc: '动态编辑',
      desc_en: 'Activity Edit'
    },
    {
      path: '/user/bind',
      desc: '账号绑定',
      desc_en: 'User Bind'
    }
  ];

const methods = {

  currentMenuIndex(route) {
    let path = route.path;
    if (path == '/') {
      return 0;
    }
    for (let i = 0; i < tabList.length; i++) {
      let item = tabList[i];
      if (item.src == '/') {
        continue;
      }
      if (path.indexOf(item.src) != -1) {

        return i;
      }


      // if (path == item.src) {
      //   return i;
      // }
    }
    return -1;
  },

  currentMenuItem(route) {
    let index = this.currentMenuIndex(route);
    if (index == -1) {
      return null;
    }
    return  tabList[index];
  },

  subMenuLlist(route) {
    let currentItem = this.currentMenuItem(route);
    if (currentItem == null) {
      return null;
    }

    let subList = currentItem.subList;
    if (subList == undefined || subList == null || subList.length == 0) {
      return  null;
    }
    return subList;
  },

  subTabIndex(route) {
    let currentItem = this.currentMenuItem(route);
    let subList = this.subMenuLlist(route);
    if (currentItem == null || subList == null) {
      return -1;
    }

    let id = route.params.id;

    if (id == undefined || id == null) {
      if (currentItem.default != undefined && currentItem.default != null) {
        id = currentItem.default;
      } else {
        return -1;
      }
    }

    for (let i = 0; i < subList.length; i++) {
      let subItem = subList[i];
      if (id == subItem.id) {
        return i;
      }
    }
    return -1;
  },
  currentSubTabId(route) {
    let subList = this.subMenuLlist(route);
    let subIndex = this.subTabIndex(route);
    if (subIndex == -1) {
      return null;
    }
    return subList[subIndex].id;
  },

  isPhoneNumber(phoneNum) {
    let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
    return reg.test(phoneNum);
  },

  //分享
  share(type) {
    if (type='qzone') {

    }
  }
}

export default {
  name: 'GlobalInstance',
  tabList,
  personUrl,
  groupUrl,
  whiteList,
  methods,
  search: {
    searchClose(router, searchText) {

      let encodeText = encodeURI(searchText)

      let url= router.resolve({
        name: 'searchPage',
        params: {
          searchText: encodeText,
        }
      });
      window.open(url.href,'_blank');
    },

    refreshSearchPage(router, searchText) {
      let encodeText = encodeURI(searchText)
      let url=  router.resolve({
        name: 'searchPage',
        params: {
          searchText: encodeText,
        }
      });

      window.location.href = url.href;
      // window.open()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/shba.js